export const dropzoneStyle = {
  border: '2px dashed #ccc',
  borderRadius: '4px',
  padding: '20px',
  marginTop: '20px',
  cursor: 'pointer',
};

export const imageContainerStyle = {
  display: 'inline-block',
  marginRight: '10px',
  marginBottom: '10px',
};

export const imageStyle = {
  width: '100px',
  height: '70px',
};

export const removeButtonStyle = {
  // position: 'absolute',
  // top: '0',
  // right: '0',
  background: 'rgba(255,255,255,0.8)',
};

export const fileIconContainerStyle: React.CSSProperties = {
  position: 'relative',
};

export const closeButtonContainerStyle: React.CSSProperties = {
  position: 'absolute',
  top: 0,
  right: 0,
};

export const downloadButtonStyle = {
  position: 'absolute',
  bottom: '0',
  left: '0',
  background: 'rgba(255,255,255,0.8)',
};
